"use client";

import Link from "next/link";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-24 text-center">
      <div className="mb-6 text-6xl">&#9888;&#65039;</div>
      <h1 className="mb-3 text-[28px] font-bold text-text-primary sm:text-[36px]">
        Something Went Wrong
      </h1>
      <p className="mb-8 max-w-md text-[14px] leading-relaxed text-text-tertiary">
        An unexpected error occurred. Please try again or navigate back to the homepage.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          onClick={reset}
          className="bg-accent-blue px-5 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-accent-hover"
        >
          Try Again
        </button>
        <Link
          href="/"
          className="border border-border px-5 py-2.5 text-[13px] font-semibold text-text-primary transition-colors hover:border-accent hover:text-accent"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
